// src/pages/supervisor/MarketDashboard.jsx
import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { Link } from "react-router-dom";
import { 
  Button, 
  Card, 
  Col, 
  Row, 
  Table, 
  Badge,
  ProgressBar,
  ButtonGroup,
  Spinner,
  Placeholder,
  Alert,
  Dropdown
} from "react-bootstrap";
import ReactApexChart from "react-apexcharts";
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { 
  CurrencyDollar, 
  People, 
  Clock,
  Receipt,
  Building,
  Calendar,
  ArrowUp,
  ArrowDown,
  Cash,
  CreditCard,
  Phone,
  ArrowUpRight,
  Eye,
  CheckCircle,
  Activity,
  BarChart,
  PieChart,
  Globe,
  ExclamationCircle,
  CashStack,
  Bank,
  Wallet,
  ClockHistory,
  X,
  Repeat,
  Trophy,
  Shop,
  Person,
  ListCheck,
  Bullseye,
  GraphUp,
  Trash,
  Download,
  FilePdf,
  FileEarmarkExcel,
  Printer
} from "react-bootstrap-icons";
import { API_BASE_URL } from "../../constants/api_constants";

export default function MarketDashboard() {
  const defaultCurrency = sessionStorage.getItem("default_currency") || 'XOF';
  const user = JSON.parse(sessionStorage.getItem('userData') || '{}');
  const dashboardRef = useRef(null);
  
  const [dashboardData, setDashboardData] = useState({
    stats: null,
    dailyCollection: null,
    contribuables: [],
    agentsPerformance: [],
    objectives: null,
    recentPayments: [],
    evolution: [],
    salubrite: null
  });
  
  const [loading, setLoading] = useState(true);
  const [loadingStats, setLoadingStats] = useState(true);
  const [loadingContribuables, setLoadingContribuables] = useState(true);
  const [loadingAgents, setLoadingAgents] = useState(true);
  const [loadingObjectives, setLoadingObjectives] = useState(true);
  const [loadingEvolution, setLoadingEvolution] = useState(true);
  const [loadingSalubrite, setLoadingSalubrite] = useState(true);
  const [error, setError] = useState(null);
  const [timeRange, setTimeRange] = useState("day");
  const [refreshLoading, setRefreshLoading] = useState(false);
  const [periodLabel, setPeriodLabel] = useState("Aujourd'hui");
  const [isFiltering, setIsFiltering] = useState(false);
  const [marcheNom, setMarcheNom] = useState('');
  const [exportLoading, setExportLoading] = useState(false);
  
  const [stats, setStats] = useState({
    totalContribuables: 0,
    totalCollecteJour: 0,
    totalAttendu: 0,
    totalPaye: 0,
    tauxRecouvrement: 0,
    objectifJour: 0,
    objectifMois: 0,
    objectifSemaine: 0,
    objectifAnnee: 0,
    objectifTotal: 0,
    atteintJour: 0,
    atteintMois: 0,
    atteintSemaine: 0,
    atteintAnnee: 0,
    atteintTotal: 0
  });

  const [objectives, setObjectives] = useState({
    daily: { target: 0, collected: 0, percentage: 0 },
    weekly: { target: 0, collected: 0, percentage: 0 },
    monthly: { target: 0, collected: 0, percentage: 0 },
    yearly: { target: 0, collected: 0, percentage: 0 },
    total: { target: 0, collected: 0, percentage: 0 }
  });

  const [evolutionData, setEvolutionData] = useState({
    categories: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
    collecte: [0, 0, 0, 0, 0, 0, 0],
    objectif: [0, 0, 0, 0, 0, 0, 0]
  });

  const [salubriteStats, setSalubriteStats] = useState({
    total_attendu: 0,
    total_collecte: 0,
    taux_recouvrement: 0,
    nombre_contribuables: 0,
    nombre_paiements: 0,
    evolution: [],
    taxe_nom: 'Taxe Salubrité'
  });

  const [salubriteEvolutionData, setSalubriteEvolutionData] = useState({
    categories: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
    collecte: [0, 0, 0, 0, 0, 0, 0]
  });

  const getAuthToken = () => sessionStorage.getItem("authToken");
  const getHeaders = () => {
    const token = getAuthToken();
    const headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    return headers;
  };

  const formatCurrency = (amount) => {
    const numAmount = parseFloat(amount) || 0;
    return numAmount.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' ' + defaultCurrency;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    } catch (e) { return dateString; }
  };

  // 👈 getPeriodLabel mis à jour avec Année et Tous
  const getPeriodLabel = (range) => {
    switch(range) {
      case 'day': return 'Aujourd\'hui';
      case 'week': return 'Cette semaine';
      case 'month': return 'Ce mois';
      case 'year': return 'Cette année';
      case 'all': return 'Toutes périodes';
      default: return 'Aujourd\'hui';
    }
  };

  // ✅ Fonction utilitaire pour récupérer l'objectif selon le timeRange
  const getCurrentObjective = () => {
    switch(timeRange) {
      case 'day': return stats.objectifJour || 0;
      case 'week': return stats.objectifSemaine || 0;
      case 'month': return stats.objectifMois || 0;
      case 'year': return stats.objectifAnnee || 0;
      case 'all': return stats.objectifTotal || stats.totalAttendu || 0;
      default: return stats.objectifJour || 0;
    }
  };

  // ✅ Fonction utilitaire pour récupérer le taux d'atteinte selon le timeRange
  const getCurrentAchievement = () => {
    switch(timeRange) {
      case 'day': return stats.atteintJour || 0;
      case 'week': return stats.atteintSemaine || 0;
      case 'month': return stats.atteintMois || 0;
      case 'year': return stats.atteintAnnee || 0;
      case 'all': return stats.tauxRecouvrement || 0;
      default: return stats.atteintJour || 0;
    }
  };

  // ✅ Fonction utilitaire pour le libellé de l'objectif
  const getObjectiveLabel = () => {
    switch(timeRange) {
      case 'day': return 'Objectif du jour';
      case 'week': return 'Objectif de la semaine';
      case 'month': return 'Objectif du mois';
      case 'year': return 'Objectif de l\'année';
      case 'all': return 'Objectif total';
      default: return 'Objectif';
    }
  };

  // ✅ Fonction utilitaire pour la description de l'objectif
  const getObjectiveDescription = () => {
    switch(timeRange) {
      case 'day': return 'Objectif journalier';
      case 'week': return 'Objectif hebdomadaire';
      case 'month': return 'Objectif mensuel';
      case 'year': return 'Objectif annuel';
      case 'all': return 'Objectif global';
      default: return 'Objectif';
    }
  };

  // ✅ Fonction d'export PDF
  const exportPDF = () => {
    if (exportLoading) return;
    setExportLoading(true);
    
    try {
      const fileName = `RAPPORT_${(marcheNom || 'SECTEUR').toUpperCase()}_${new Date().toISOString().split('T')[0]}`;
      
      const originalTitle = document.title;
      document.title = fileName;
      
      const formatCurrencyPDF = (amount) => {
        const num = parseFloat(amount) || 0;
        return num.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' ' + defaultCurrency;
      };
      
      const formatDatePDF = (dateString) => {
        if (!dateString) return "-";
        try {
          const date = new Date(dateString);
          return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
        } catch (e) { return dateString; }
      };
      
      const currentObjective = getCurrentObjective();
      const currentAchievement = getCurrentAchievement();
      
      const htmlContent = `<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <title>${fileName}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: Arial, Helvetica, sans-serif; padding: 4mm 5mm; background: white; font-size: 9pt; line-height: 1.25; color: #1a1a1a; }
    .report { max-width: 100%; margin: 0 auto; }
    .header { text-align: center; padding-bottom: 4px; border-bottom: 2px solid #1a1a1a; margin-bottom: 10px; position: relative; }
    .header .top-line { font-size: 7pt; letter-spacing: 2px; text-transform: uppercase; color: #666; margin-bottom: 1px; }
    .header h1 { font-size: 14pt; font-weight: bold; letter-spacing: 2px; text-transform: uppercase; color: #1a1a1a; margin: 1px 0; }
    .header .subtitle { font-size: 11pt; font-weight: normal; color: #2a2a2a; margin-top: 1px; }
    .header .subtitle span { font-weight: bold; color: #1a3a6a; }
    .header .meta { font-size: 7.5pt; color: #555; margin-top: 2px; display: flex; justify-content: center; gap: 15px; }
    .header .meta .sep { color: #ccc; }
    .section { margin-bottom: 8px; }
    .section-title { font-size: 9.5pt; font-weight: bold; text-transform: uppercase; border-bottom: 1px solid #999; padding-bottom: 2px; margin-bottom: 5px; color: #1a1a1a; letter-spacing: 0.3px; }
    .stats-grid { display: table; width: 100%; border-collapse: collapse; }
    .stats-row { display: table-row; }
    .stat-item { display: table-cell; padding: 2px 4px; border-bottom: 1px solid #eee; vertical-align: middle; }
    .stat-item .label { font-size: 8pt; color: #444; }
    .stat-item .value { font-size: 9.5pt; font-weight: bold; text-align: right; }
    .stat-item .value.green { color: #1a7a3a; }
    .stat-item .value.blue { color: #1a3a6a; }
    .stat-item .value.orange { color: #b85a1a; }
    .stat-item .value.red { color: #8a1a1a; }
    table { width: 100%; border-collapse: collapse; font-size: 8pt; margin-top: 2px; }
    table thead th { background: #f0f0f0; padding: 3px 5px; text-align: left; font-weight: bold; border-bottom: 2px solid #666; font-size: 7pt; text-transform: uppercase; letter-spacing: 0.3px; }
    table tbody td { padding: 2px 5px; border-bottom: 1px solid #e8e8e8; font-size: 8pt; }
    table tbody tr:nth-child(even) { background: #f8f8f8; }
    .text-right { text-align: right; }
    .text-center { text-align: center; }
    .fw-bold { font-weight: bold; }
    .objectives-grid { display: table; width: 100%; border-collapse: collapse; margin-top: 2px; }
    .objectives-row { display: table-row; }
    .obj-item { display: table-cell; padding: 4px 6px; border: 1px solid #ccc; text-align: center; vertical-align: middle; width: 20%; }
    .obj-item .period { font-size: 7pt; font-weight: bold; text-transform: uppercase; color: #444; letter-spacing: 0.3px; }
    .obj-item .percent { font-size: 13pt; font-weight: bold; margin: 1px 0; }
    .obj-item .percent.green { color: #1a7a3a; }
    .obj-item .percent.orange { color: #b85a1a; }
    .obj-item .percent.red { color: #8a1a1a; }
    .obj-item .details { font-size: 7pt; color: #333; }
    .obj-item .details .collected { color: #1a7a3a; font-weight: bold; }
    .badge { display: inline-block; padding: 1px 6px; border: 1px solid #666; font-size: 7.5pt; font-weight: bold; }
    .badge.success { border-color: #1a7a3a; color: #1a7a3a; }
    .badge.warning { border-color: #b85a1a; color: #b85a1a; }
    .badge.danger { border-color: #8a1a1a; color: #8a1a1a; }
    .footer { margin-top: 12px; padding-top: 4px; border-top: 1px solid #ccc; font-size: 7pt; color: #777; display: flex; justify-content: space-between; }
    @media print { body { padding: 3mm 4mm; } .stat-item { break-inside: avoid; } .obj-item { break-inside: avoid; } table { break-inside: auto; } }
  </style>
</head>
<body>
  <div class="report">
    <div class="header">
      <div class="top-line">● ● ● RÉPUBLIQUE DÉMOCRATIQUE DU CONGO ● ● ●</div>
      <h1>RAPPORT DE GESTION</h1>
      <div class="subtitle">SECTEUR <span>${(marcheNom || 'GLOBAL').toUpperCase()}</span></div>
      <div class="meta">
        <span>Période : ${periodLabel}</span>
        <span class="sep">|</span>
        <span>${new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })}</span>
        <span class="sep">|</span>
        <span>${new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</span>
      </div>
    </div>
    
    <div class="section">
      <div class="section-title">1. Synthèse des indicateurs</div>
      <div class="stats-grid">
        <div class="stats-row">
          <div class="stat-item"><span class="label">Contribuables enregistrés</span></div>
          <div class="stat-item"><span class="value">${stats.totalContribuables}</span></div>
          <div class="stat-item"><span class="label">Collecte de la période</span></div>
          <div class="stat-item"><span class="value green">${formatCurrencyPDF(stats.totalCollecteJour)}</span></div>
        </div>
        <div class="stats-row">
          <div class="stat-item"><span class="label">Objectif ${timeRange === 'day' ? 'journalier' : timeRange === 'week' ? 'hebdomadaire' : timeRange === 'month' ? 'mensuel' : timeRange === 'year' ? 'annuel' : 'global'}</span></div>
          <div class="stat-item"><span class="value blue">${formatCurrencyPDF(currentObjective)}</span></div>
          <div class="stat-item"><span class="label">Taux d'atteinte</span></div>
          <div class="stat-item"><span class="value ${currentAchievement >= 80 ? 'green' : currentAchievement >= 50 ? 'orange' : 'red'}">${currentAchievement} %</span></div>
        </div>
        <div class="stats-row">
          <div class="stat-item"><span class="label">Total attendu</span></div>
          <div class="stat-item"><span class="value">${formatCurrencyPDF(stats.totalAttendu)}</span></div>
          <div class="stat-item"><span class="label">Total payé</span></div>
          <div class="stat-item"><span class="value green">${formatCurrencyPDF(stats.totalPaye)}</span></div>
        </div>
        <div class="stats-row">
          <div class="stat-item"><span class="label">Taux de recouvrement global</span></div>
          <div class="stat-item" colspan="3"><span class="value ${stats.tauxRecouvrement >= 80 ? 'green' : stats.tauxRecouvrement >= 50 ? 'orange' : 'red'}">${stats.tauxRecouvrement} %</span></div>
        </div>
      </div>
    </div>
    
    <div class="section">
      <div class="section-title">2. Suivi des objectifs</div>
      <div class="objectives-grid">
        <div class="objectives-row">
          <div class="obj-item">
            <div class="period">Journalier</div>
            <div class="percent ${objectives.daily.percentage >= 80 ? 'green' : objectives.daily.percentage >= 50 ? 'orange' : 'red'}">${objectives.daily.percentage} %</div>
            <div class="details"><span class="collected">${formatCurrencyPDF(objectives.daily.collected)}</span> / ${formatCurrencyPDF(objectives.daily.target)}</div>
          </div>
          <div class="obj-item">
            <div class="period">Hebdomadaire</div>
            <div class="percent ${objectives.weekly.percentage >= 80 ? 'green' : objectives.weekly.percentage >= 50 ? 'orange' : 'red'}">${objectives.weekly.percentage} %</div>
            <div class="details"><span class="collected">${formatCurrencyPDF(objectives.weekly.collected)}</span> / ${formatCurrencyPDF(objectives.weekly.target)}</div>
          </div>
          <div class="obj-item">
            <div class="period">Mensuel</div>
            <div class="percent ${objectives.monthly.percentage >= 80 ? 'green' : objectives.monthly.percentage >= 50 ? 'orange' : 'red'}">${objectives.monthly.percentage} %</div>
            <div class="details"><span class="collected">${formatCurrencyPDF(objectives.monthly.collected)}</span> / ${formatCurrencyPDF(objectives.monthly.target)}</div>
          </div>
          <div class="obj-item">
            <div class="period">Annuel</div>
            <div class="percent ${objectives.yearly.percentage >= 80 ? 'green' : objectives.yearly.percentage >= 50 ? 'orange' : 'red'}">${objectives.yearly.percentage} %</div>
            <div class="details"><span class="collected">${formatCurrencyPDF(objectives.yearly.collected)}</span> / ${formatCurrencyPDF(objectives.yearly.target)}</div>
          </div>
          <div class="obj-item">
            <div class="period">Total</div>
            <div class="percent ${objectives.total.percentage >= 80 ? 'green' : objectives.total.percentage >= 50 ? 'orange' : 'red'}">${objectives.total.percentage} %</div>
            <div class="details"><span class="collected">${formatCurrencyPDF(objectives.total.collected)}</span> / ${formatCurrencyPDF(objectives.total.target)}</div>
          </div>
        </div>
      </div>
    </div>
    
    ${dashboardData.agentsPerformance && dashboardData.agentsPerformance.length > 0 ? `
    <div class="section">
      <div class="section-title">3. Performance des agents</div>
      <table>
        <thead>
          <tr><th style="width:20px;">N°</th><th>Agent</th><th class="text-right" style="width:80px;">Collecté</th><th class="text-right" style="width:80px;">Objectif</th><th class="text-center" style="width:60px;">Taux</th></tr>
        </thead>
        <tbody>
          ${dashboardData.agentsPerformance.slice(0, 10).map((agent, idx) => `
            <tr>
              <td>${idx + 1}</td>
              <td><strong>${agent.nom || 'Agent'}</strong></td>
              <td class="text-right fw-bold">${formatCurrencyPDF(agent.collecte || 0)}</td>
              <td class="text-right">${formatCurrencyPDF(agent.objectif || 0)}</td>
              <td class="text-center"><span class="badge ${(agent.performance || 0) >= 80 ? 'success' : (agent.performance || 0) >= 50 ? 'warning' : 'danger'}">${agent.performance || 0}%</span></td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      ${dashboardData.agentsPerformance.length > 10 ? `<p style="margin-top:2px; font-size:7pt; color:#888;">... ${dashboardData.agentsPerformance.length - 10} agent(s) supplémentaire(s)</p>` : ''}
    </div>
    ` : ''}
    
    ${salubriteStats.total_attendu > 0 || salubriteStats.total_collecte > 0 ? `
    <div class="section">
      <div class="section-title">4. ${salubriteStats.taxe_nom || 'Taxe Salubrité'}</div>
      <table>
        <thead><tr><th>Indicateur</th><th class="text-right">Valeur</th></tr></thead>
        <tbody>
          <tr><td>Total attendu</td><td class="text-right fw-bold">${formatCurrencyPDF(salubriteStats.total_attendu)}</td></tr>
          <tr><td>Total collecté</td><td class="text-right fw-bold green">${formatCurrencyPDF(salubriteStats.total_collecte)}</td></tr>
          <tr><td>Taux de recouvrement</td><td class="text-right fw-bold ${salubriteStats.taux_recouvrement >= 80 ? 'green' : 'orange'}">${salubriteStats.taux_recouvrement}%</td></tr>
          <tr><td>Contribuables</td><td class="text-right fw-bold">${salubriteStats.nombre_contribuables}</td></tr>
          <tr><td>Paiements effectués</td><td class="text-right fw-bold">${salubriteStats.nombre_paiements}</td></tr>
        </tbody>
      </table>
    </div>
    ` : ''}
    
    ${dashboardData.recentPayments && dashboardData.recentPayments.length > 0 ? `
    <div class="section">
      <div class="section-title">5. Dernières transactions</div>
      <table>
        <thead><tr><th style="width:100px;">Date</th><th>Contribuable</th><th class="text-right" style="width:80px;">Montant</th><th style="width:100px;">Agent</th></tr></thead>
        <tbody>
          ${dashboardData.recentPayments.slice(0, 12).map(p => `
            <tr>
              <td>${formatDatePDF(p.created_at)}</td>
              <td><strong>${p.contribuable || 'Inconnu'}</strong></td>
              <td class="text-right fw-bold">${formatCurrencyPDF(p.montant || 0)}</td>
              <td>${p.agent || '-'}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      ${dashboardData.recentPayments.length > 12 ? `<p style="margin-top:2px; font-size:7pt; color:#888;">... ${dashboardData.recentPayments.length - 12} transaction(s) supplémentaire(s)</p>` : ''}
    </div>
    ` : ''}
    
    <div class="footer">
      <span>Généré par SyncTaxe</span>
      <span>${marcheNom || 'Secteur'} • ${new Date().toLocaleDateString('fr-FR')}</span>
    </div>
  </div>
</body>
</html>`;
      
      const iframe = document.createElement('iframe');
      iframe.style.position = 'absolute';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      document.body.appendChild(iframe);
      
      const iframeDoc = iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(htmlContent);
      iframeDoc.close();
      
      iframe.contentWindow.onload = () => {
        iframe.contentWindow.document.title = fileName;
        iframe.contentWindow.print();
        
        setTimeout(() => {
          document.title = originalTitle;
          if (document.body.contains(iframe)) document.body.removeChild(iframe);
          setExportLoading(false);
          showNotification('PDF exporté avec succès', 'success');
        }, 1500);
      };
      
      iframe.onerror = () => {
        document.title = originalTitle;
        if (document.body.contains(iframe)) document.body.removeChild(iframe);
        setExportLoading(false);
        showNotification('Erreur lors de l\'export PDF', 'danger');
      };
      
    } catch (err) {
      console.error('Erreur export PDF:', err);
      showNotification('Erreur lors de l\'export PDF', 'danger');
      setExportLoading(false);
    }
  };

  // ✅ Fonction d'export Excel
  const exportExcel = () => {
    if (exportLoading) return;
    setExportLoading(true);
    
    try {
      const wb = XLSX.utils.book_new();
      
      const formatDateExcel = (dateString) => {
        if (!dateString) return "-";
        try {
          const date = new Date(dateString);
          return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
        } catch (e) { return dateString; }
      };
      
      const currentObjective = getCurrentObjective();
      const currentAchievement = getCurrentAchievement();
      
      // ===== SHEET 1: RÉSUMÉ EXÉCUTIF =====
      const resumeData = [
        ['RAPPORT DE GESTION'],
        [''],
        ['Secteur', marcheNom || 'Global'],
        ['Période', periodLabel],
        ['Date de génération', new Date().toLocaleDateString('fr-FR')],
        ['Heure de génération', new Date().toLocaleTimeString('fr-FR')],
        [''],
        ['INDICATEURS CLÉS'],
        ['Indicateur', 'Valeur'],
        ['Total Contribuables', stats.totalContribuables],
        ['Collecte de la période', stats.totalCollecteJour],
        ['Objectif de la période', currentObjective],
        ['Taux d\'atteinte', currentAchievement + '%'],
        ['Total attendu', stats.totalAttendu],
        ['Total payé', stats.totalPaye],
        ['Taux de recouvrement', stats.tauxRecouvrement + '%'],
        [''],
        ['DÉTAIL DES MONTANTS'],
        ['Description', 'Montant'],
        ['Collecte journalière', stats.totalCollecteJour],
        ['Objectif ' + (timeRange === 'day' ? 'journalier' : timeRange === 'week' ? 'hebdomadaire' : timeRange === 'month' ? 'mensuel' : timeRange === 'year' ? 'annuel' : 'global'), currentObjective],
        ['Écart (Collecté - Objectif)', stats.totalCollecteJour - currentObjective]
      ];
      
      const ws1 = XLSX.utils.aoa_to_sheet(resumeData);
      ws1['!cols'] = [{ wch: 35 }, { wch: 30 }];
      ws1['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }];
      XLSX.utils.book_append_sheet(wb, ws1, 'Résumé Exécutif');
      
      // ===== SHEET 2: OBJECTIFS =====
      const objectivesData = [
        ['SUIVI DES OBJECTIFS'],
        [''],
        ['Période', 'Objectif', 'Collecté', 'Atteinte (%)', 'Statut'],
        ['Journalier', objectives.daily.target, objectives.daily.collected, objectives.daily.percentage, objectives.daily.percentage >= 80 ? '✅ ATTEINT' : objectives.daily.percentage >= 50 ? '⚠️ EN COURS' : '❌ NON ATTEINT'],
        ['Hebdomadaire', objectives.weekly.target, objectives.weekly.collected, objectives.weekly.percentage, objectives.weekly.percentage >= 80 ? '✅ ATTEINT' : objectives.weekly.percentage >= 50 ? '⚠️ EN COURS' : '❌ NON ATTEINT'],
        ['Mensuel', objectives.monthly.target, objectives.monthly.collected, objectives.monthly.percentage, objectives.monthly.percentage >= 80 ? '✅ ATTEINT' : objectives.monthly.percentage >= 50 ? '⚠️ EN COURS' : '❌ NON ATTEINT'],
        ['Annuel', objectives.yearly.target, objectives.yearly.collected, objectives.yearly.percentage, objectives.yearly.percentage >= 80 ? '✅ ATTEINT' : objectives.yearly.percentage >= 50 ? '⚠️ EN COURS' : '❌ NON ATTEINT'],
        ['Total', objectives.total.target, objectives.total.collected, objectives.total.percentage, objectives.total.percentage >= 80 ? '✅ ATTEINT' : objectives.total.percentage >= 50 ? '⚠️ EN COURS' : '❌ NON ATTEINT']
      ];
      
      const ws2 = XLSX.utils.aoa_to_sheet(objectivesData);
      ws2['!cols'] = [{ wch: 18 }, { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 20 }];
      ws2['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }];
      XLSX.utils.book_append_sheet(wb, ws2, 'Objectifs');
      
      // ===== SHEET 3: PERFORMANCE DES AGENTS =====
      if (dashboardData.agentsPerformance && dashboardData.agentsPerformance.length > 0) {
        const agentsData = [
          ['PERFORMANCE DES AGENTS'],
          [''],
          ['#', 'Agent', 'Fonction', 'Collecté', 'Objectif', 'Performance (%)', 'Classement'],
          ...dashboardData.agentsPerformance.map((agent, idx) => {
            const perf = agent.performance || 0;
            let rank = '';
            if (perf >= 100) rank = '🏆 Excellent';
            else if (perf >= 80) rank = '⭐ Très bon';
            else if (perf >= 60) rank = '👍 Bon';
            else if (perf >= 40) rank = '📈 En progrès';
            else rank = '📉 À améliorer';
            return [idx + 1, agent.nom || 'Agent', agent.role || 'Agent de collecte', agent.collecte || 0, agent.objectif || 0, perf, rank];
          })
        ];
        
        const ws3 = XLSX.utils.aoa_to_sheet(agentsData);
        ws3['!cols'] = [{ wch: 5 }, { wch: 25 }, { wch: 20 }, { wch: 18 }, { wch: 18 }, { wch: 15 }, { wch: 20 }];
        ws3['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }];
        XLSX.utils.book_append_sheet(wb, ws3, 'Agents');
      }
      
      // ===== SHEET 4: TAXE SALUBRITÉ =====
      if (salubriteStats.total_attendu > 0 || salubriteStats.total_collecte > 0) {
        const salubriteData = [
          [salubriteStats.taxe_nom || 'TAXE SALUBRITÉ'],
          [''],
          ['Indicateur', 'Valeur'],
          ['Total attendu', salubriteStats.total_attendu],
          ['Total collecté', salubriteStats.total_collecte],
          ['Taux de recouvrement', salubriteStats.taux_recouvrement + '%'],
          ['Nombre de contribuables', salubriteStats.nombre_contribuables],
          ['Nombre de paiements', salubriteStats.nombre_paiements]
        ];
        
        const ws4 = XLSX.utils.aoa_to_sheet(salubriteData);
        ws4['!cols'] = [{ wch: 30 }, { wch: 30 }];
        ws4['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }];
        XLSX.utils.book_append_sheet(wb, ws4, 'Taxe Salubrité');
      }
      
      // ===== SHEET 5: ACTIVITÉS RÉCENTES =====
      if (dashboardData.recentPayments && dashboardData.recentPayments.length > 0) {
        const recentData = [
          ['ACTIVITÉS RÉCENTES'],
          [''],
          ['Date', 'Contribuable', 'Montant', 'Agent'],
          ...dashboardData.recentPayments.slice(0, 50).map(p => [
            formatDateExcel(p.created_at),
            p.contribuable || 'Inconnu',
            p.montant || 0,
            p.agent || '-'
          ])
        ];
        
        const ws5 = XLSX.utils.aoa_to_sheet(recentData);
        ws5['!cols'] = [{ wch: 20 }, { wch: 30 }, { wch: 18 }, { wch: 20 }];
        ws5['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 3 } }];
        XLSX.utils.book_append_sheet(wb, ws5, 'Activités');
      }
      
      const fileName = `RAPPORT_${(marcheNom || 'SECTEUR').toUpperCase()}_${new Date().toISOString().split('T')[0]}`;
      XLSX.writeFile(wb, `${fileName}.xlsx`);
      
      showNotification('📊 Excel exporté avec succès !', 'success');
      
    } catch (err) {
      console.error('Erreur export Excel:', err);
      showNotification('❌ Erreur lors de l\'export Excel', 'danger');
    } finally {
      setExportLoading(false);
    }
  };

  // ✅ Fonction de notification
  const showNotification = (message, type = 'success') => {
    let toastContainer = document.getElementById('toast-container');
    if (!toastContainer) {
      toastContainer = document.createElement('div');
      toastContainer.id = 'toast-container';
      toastContainer.className = 'position-fixed top-0 end-0 p-3';
      toastContainer.style.zIndex = '9999';
      toastContainer.style.maxWidth = '450px';
      document.body.appendChild(toastContainer);
    }

    const configs = {
      success: { icon: '✔️', title: 'Succès' },
      danger: { icon: '✖️', title: 'Erreur' },
      warning: { icon: '⚠️', title: 'Attention' },
      info: { icon: 'ℹ️', title: 'Information' }
    };

    const config = configs[type] || configs.info;
    const toastId = 'toast-' + Date.now();
    const toast = document.createElement('div');
    toast.id = toastId;
    toast.className = `toast align-items-center border-0 show shadow-lg`;
    toast.style.cssText = `
      opacity: 0;
      transform: translateX(100%);
      transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
      background: white;
      border-radius: 12px;
      box-shadow: 0 10px 40px rgba(0,0,0,0.15);
      border-left: 5px solid ${type === 'success' ? '#28a745' : type === 'danger' ? '#dc3545' : type === 'warning' ? '#ffc107' : '#17a2b8'};
      min-width: 280px;
    `;
    
    toast.innerHTML = `
      <div class="d-flex align-items-center p-2">
        <div class="flex-shrink-0 ms-2">
          <div style="width: 40px; height: 40px; border-radius: 50%; background: ${type === 'success' ? '#d4edda' : type === 'danger' ? '#f8d7da' : type === 'warning' ? '#fff3cd' : '#d1ecf1'}; display: flex; align-items: center; justify-content: center; font-size: 20px;">
            ${config.icon}
          </div>
        </div>
        <div class="flex-grow-1 ms-3">
          <div class="fw-bold" style="font-size: 13px; color: #1a1a1a;">${config.title}</div>
          <div style="font-size: 12px; color: #555; line-height: 1.3;">${message}</div>
        </div>
        <button type="button" class="btn-close me-2" aria-label="Fermer" style="font-size: 10px;"></button>
      </div>
    `;

    toastContainer.appendChild(toast);

    setTimeout(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(0)';
    }, 50);

    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(100%)';
      setTimeout(() => {
        if (toast.parentNode) toast.remove();
      }, 500);
    }, 5000);

    const closeBtn = toast.querySelector('.btn-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(100%)';
        setTimeout(() => {
          if (toast.parentNode) toast.remove();
        }, 500);
      });
    }
  };

  // 🔥 CHARGEMENT DES DONNÉES
  const loadDashboardData = useCallback(async (forceRefresh = false) => {
    try {
      if (forceRefresh) {
        setRefreshLoading(true);
      } else {
        setIsFiltering(true);
        setLoading(true);
      }
      setError(null);

      const params = {
        time_range: timeRange
      };

      const response = await axios.get(`${API_BASE_URL}/supervisor/dashboard`, { 
        headers: getHeaders(), 
        params 
      });

      if (response.data.success) {
        applyDashboardData(response.data.data);
      } else {
        setError(response.data.message || 'Erreur lors du chargement');
      }
    } catch (err) {
      console.error("Erreur chargement dashboard superviseur:", err);
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
      setRefreshLoading(false);
      setIsFiltering(false);
    }
  }, [timeRange]);

  const applyDashboardData = (data) => {
    if (data.period_label) {
      setPeriodLabel(data.period_label);
    } else {
      setPeriodLabel(getPeriodLabel(timeRange));
    }

    if (data.marche_nom) {
      setMarcheNom(data.marche_nom);
    }

    setStats({
      totalContribuables: data.totalContribuables || 0,
      totalCollecteJour: data.totalCollecteJour || 0,
      totalAttendu: data.totalAttendu || 0,
      totalPaye: data.totalPaye || 0,
      tauxRecouvrement: data.tauxRecouvrement || 0,
      objectifJour: data.objectifJour || 0,
      objectifMois: data.objectifMois || 0,
      objectifSemaine: data.objectifSemaine || 0,
      objectifAnnee: data.objectifAnnee || 0,
      objectifTotal: data.objectifTotal || 0,
      atteintJour: data.atteintJour || 0,
      atteintMois: data.atteintMois || 0,
      atteintSemaine: data.atteintSemaine || 0,
      atteintAnnee: data.atteintAnnee || 0,
      atteintTotal: data.atteintTotal || 0
    });
    setLoadingStats(false);

    if (data.objectives) {
      setObjectives({
        daily: {
          target: data.objectives.daily?.target || 0,
          collected: data.objectives.daily?.collected || 0,
          percentage: data.objectives.daily?.percentage || 0
        },
        weekly: {
          target: data.objectives.weekly?.target || 0,
          collected: data.objectives.weekly?.collected || 0,
          percentage: data.objectives.weekly?.percentage || 0
        },
        monthly: {
          target: data.objectives.monthly?.target || 0,
          collected: data.objectives.monthly?.collected || 0,
          percentage: data.objectives.monthly?.percentage || 0
        },
        yearly: {
          target: data.objectives.yearly?.target || 0,
          collected: data.objectives.yearly?.collected || 0,
          percentage: data.objectives.yearly?.percentage || 0
        },
        total: {
          target: data.objectives.total?.target || 0,
          collected: data.objectives.total?.collected || 0,
          percentage: data.objectives.total?.percentage || 0
        }
      });
    }
    setLoadingObjectives(false);

    // Évolution
    if (data.evolution && Array.isArray(data.evolution) && data.evolution.length > 0) {
      const categories = data.evolution.map(item => item.mois || item.label || item.date || '');
      const collecteData = data.evolution.map(item => parseFloat(item.montant) || parseFloat(item.collecte) || 0);
      const objectifData = data.evolution.map(item => parseFloat(item.objectif) || 0);
      
      setEvolutionData({
        categories: categories.length > 0 ? categories : ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
        collecte: collecteData,
        objectif: objectifData
      });
      setLoadingEvolution(false);
    } else {
      // Fallback : générer un graphique cohérent avec le timeRange
      const today = new Date();
      const days = [];
      const collecteData = [];
      const objectifData = [];
      
      let totalObjective = 0;
      if (data.objectives) {
        if (timeRange === 'day') totalObjective = data.objectives.daily?.target || 0;
        else if (timeRange === 'week') totalObjective = data.objectives.weekly?.target || 0;
        else if (timeRange === 'month') totalObjective = data.objectives.monthly?.target || 0;
        else if (timeRange === 'year') totalObjective = data.objectives.yearly?.target || 0;
        else totalObjective = data.objectives.total?.target || 0;
      }
      
      // Nombre de points selon la période
      let daysCount = 7;
      let labelFormat = { day: 'numeric', month: 'short' };
      
      if (timeRange === 'day') {
        daysCount = 24;
      } else if (timeRange === 'week') {
        daysCount = 7;
      } else if (timeRange === 'month') {
        daysCount = 30;
      } else if (timeRange === 'year') {
        daysCount = 12;
        labelFormat = { month: 'short' };
      } else {
        daysCount = 12;
        labelFormat = { month: 'short', year: '2-digit' };
      }
      
      const dailyObjective = Math.round(totalObjective / Math.max(daysCount, 1));
      
      for (let i = daysCount - 1; i >= 0; i--) {
        const date = new Date(today);
        
        if (timeRange === 'day') {
          date.setHours(date.getHours() - i);
          days.push(date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
        } else if (timeRange === 'year' || timeRange === 'all') {
          date.setMonth(date.getMonth() - i);
          days.push(date.toLocaleDateString('fr-FR', { month: 'short' }));
        } else {
          date.setDate(date.getDate() - i);
          days.push(date.toLocaleDateString('fr-FR', labelFormat));
        }
        
        collecteData.push(0);
        objectifData.push(dailyObjective);
      }
      
      setEvolutionData({
        categories: days,
        collecte: collecteData,
        objectif: objectifData
      });
      setLoadingEvolution(false);
    }

    // Salubrité
    if (data.salubrite) {
      setSalubriteStats({
        total_attendu: data.salubrite.total_attendu || 0,
        total_collecte: data.salubrite.total_collecte || 0,
        taux_recouvrement: data.salubrite.taux_recouvrement || 0,
        nombre_contribuables: data.salubrite.nombre_contribuables || 0,
        nombre_paiements: data.salubrite.nombre_paiements || 0,
        evolution: data.salubrite.evolution || [],
        taxe_nom: data.salubrite.taxe_nom || 'Taxe Salubrité'
      });
      
      if (data.salubrite.evolution && data.salubrite.evolution.length > 0) {
        const categories = data.salubrite.evolution.map(item => item.mois || '');
        const collecteData = data.salubrite.evolution.map(item => parseFloat(item.montant) || 0);
        
        setSalubriteEvolutionData({
          categories: categories.length > 0 ? categories : ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
          collecte: collecteData
        });
      } else {
        const today = new Date();
        const days = [];
        const collecteData = [];
        
        for (let i = 6; i >= 0; i--) {
          const date = new Date(today);
          date.setDate(date.getDate() - i);
          const label = date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
          days.push(label);
          collecteData.push(0);
        }
        
        setSalubriteEvolutionData({
          categories: days,
          collecte: collecteData
        });
      }
      setLoadingSalubrite(false);
    }

    setDashboardData(prev => ({
      ...prev,
      contribuables: data.contribuables || [],
      agentsPerformance: data.agents_performance || [],
      recentPayments: data.recent_payments || [],
      evolution: data.evolution || [],
      salubrite: data.salubrite || null
    }));
    setLoadingContribuables(false);
    setLoadingAgents(false);
  };

  const handleTimeRangeChange = (newRange) => {
    if (newRange === timeRange) return;
    setIsFiltering(true);
    setTimeRange(newRange);
  };

  useEffect(() => {
    loadDashboardData();
  }, [timeRange]);

  // Configuration des graphiques
  const revenueChartOptions = useMemo(() => ({
    chart: { 
      type: 'area', 
      height: 200, 
      toolbar: { show: false },
      animations: { enabled: true, easing: 'easeinout', speed: 800 },
      background: 'transparent'
    },
    colors: ['#2ecc71', '#9b59b6'],
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 0.5,
        opacityFrom: 0.8,
        opacityTo: 0.2,
        stops: [0, 90, 100]
      }
    },
    dataLabels: { 
      enabled: evolutionData.collecte.some(v => v > 0),
      formatter: (val) => {
        if (val === 0) return '0';
        return val.toLocaleString('fr-FR');
      },
      offsetY: -8,
      style: { fontSize: '9px', fontWeight: 'bold' }
    },
    stroke: { curve: 'smooth', width: 3 },
    xaxis: {
      categories: evolutionData.categories,
      labels: { 
        style: { colors: '#495057', fontSize: '10px' },
        rotate: 0
      }
    },
    yaxis: {
      labels: { 
        formatter: (value) => {
          if (value === 0) return '0';
          return value.toLocaleString('fr-FR');
        },
        style: { colors: '#6c757d', fontSize: '10px' }
      }
    },
    tooltip: {
      y: { 
        formatter: (value) => `${value.toLocaleString('fr-FR')} ${defaultCurrency}`,
        title: { formatter: (seriesName) => `<strong>${seriesName}</strong>` }
      },
      shared: true,
      intersect: false
    },
    legend: { 
      position: 'top', 
      horizontalAlign: 'center',
      fontSize: '10px',
      fontWeight: 600,
      markers: { width: 10, height: 10, radius: 4 }
    },
    grid: { borderColor: '#e0e6ed', strokeDashArray: 5 }
  }), [evolutionData, defaultCurrency]);

  const revenueSeries = useMemo(() => [
    { name: 'Collecté', data: evolutionData.collecte },
    { name: 'Objectif', data: evolutionData.objectif }
  ], [evolutionData]);

  const salubriteChartOptions = useMemo(() => ({
    chart: { 
      type: 'area', 
      height: 180, 
      toolbar: { show: false },
      animations: { enabled: true, easing: 'easeinout', speed: 800 },
      background: 'transparent'
    },
    colors: ['#e74c3c'],
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 0.5,
        opacityFrom: 0.8,
        opacityTo: 0.2,
        stops: [0, 90, 100]
      }
    },
    dataLabels: { 
      enabled: salubriteEvolutionData.collecte.some(v => v > 0),
      formatter: (val) => {
        if (val === 0) return '0';
        return val.toLocaleString('fr-FR');
      },
      offsetY: -8,
      style: { fontSize: '8px', fontWeight: 'bold' }
    },
    stroke: { curve: 'smooth', width: 2 },
    xaxis: {
      categories: salubriteEvolutionData.categories,
      labels: { 
        style: { colors: '#495057', fontSize: '9px' },
        rotate: 0
      }
    },
    yaxis: {
      labels: { 
        formatter: (value) => {
          if (value === 0) return '0';
          return value.toLocaleString('fr-FR');
        },
        style: { colors: '#6c757d', fontSize: '9px' }
      }
    },
    tooltip: {
      y: { 
        formatter: (value) => `${value.toLocaleString('fr-FR')} ${defaultCurrency}`,
        title: { formatter: () => `<strong>Taxe Salubrité</strong>` }
      },
      shared: true,
      intersect: false
    },
    legend: { show: false },
    grid: { borderColor: '#e0e6ed', strokeDashArray: 5 }
  }), [salubriteEvolutionData, defaultCurrency]);

  const salubriteSeries = useMemo(() => [
    { name: 'Taxe Salubrité', data: salubriteEvolutionData.collecte }
  ], [salubriteEvolutionData]);

  const objectiveChartOptionsSmall = {
    chart: { type: 'radialBar', height: 150, toolbar: { show: false } },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 270,
        hollow: { margin: 0, size: '70%', background: 'transparent' },
        dataLabels: {
          name: { show: true, fontSize: '11px', fontWeight: 500, color: '#6c757d' },
          value: { fontSize: '18px', fontWeight: 'bold', color: '#2c3e50', offsetY: 5 }
        },
        track: { background: '#e9ecef' }
      }
    },
    stroke: { lineCap: 'round' }
  };

  const agentsChartOptions = {
    chart: { type: 'bar', height: 200, toolbar: { show: false } },
    colors: ['#9b59b6', '#3498db'],
    plotOptions: { bar: { borderRadius: 0, horizontal: false, columnWidth: '50%' } },
    dataLabels: { enabled: false },
    xaxis: { categories: dashboardData.agentsPerformance.map(a => a.nom || 'Agent') || [] },
    yaxis: { 
      labels: { formatter: (value) => `${value.toLocaleString('fr-FR')}` }
    },
    legend: { position: 'top' }
  };

  const agentsSeries = [
    { name: 'Collecté', data: dashboardData.agentsPerformance.map(a => a.collecte || 0) || [] },
    { name: 'Objectif', data: dashboardData.agentsPerformance.map(a => a.objectif || 0) || [] }
  ];

  const StatCard = ({ title, value, icon: Icon, color, description, loading }) => (
    <Card className="border-0 shadow-sm h-100 bg-white stats-card">
      <div className={`position-absolute top-0 start-0 w-100 bg-${color}`} style={{ height: '4px' }} />
      <Card.Body className="p-4">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="rounded-3 p-2" style={{ backgroundColor: `rgba(var(--bs-${color}-rgb), 0.1)` }}>
            <Icon className={`text-${color}`} size={20} />
          </div>
        </div>
        {loading ? (
          <Placeholder as="div" animation="glow">
            <Placeholder xs={6} style={{ height: '30px' }} className="mb-2" />
            <Placeholder xs={8} style={{ height: '14px' }} />
          </Placeholder>
        ) : (
          <>
            <h3 className="fw-bold mb-1">{typeof value === 'number' ? value.toLocaleString('fr-FR') : value}</h3>
            <span className="text-uppercase fw-semibold" style={{ fontSize: '11px', color: '#64748b' }}>{title}</span>
            {description && <p className="text-muted small mb-0 mt-1">{description}</p>}
          </>
        )}
      </Card.Body>
    </Card>
  );

  const SkeletonStatCard = () => (
    <Card className="border-0 shadow-sm h-100 bg-white stats-card">
      <div className="position-absolute top-0 start-0 w-100" style={{ height: '4px', backgroundColor: '#e9ecef' }} />
      <Card.Body className="p-4">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="rounded-3 p-2" style={{ backgroundColor: 'rgba(13, 110, 253, 0.1)' }}>
            <div className="rounded-circle" style={{ width: '20px', height: '20px', backgroundColor: '#e9ecef' }} />
          </div>
        </div>
        <Placeholder as="div" animation="glow">
          <Placeholder xs={6} style={{ height: '30px' }} className="mb-2" />
          <Placeholder xs={8} style={{ height: '14px' }} />
        </Placeholder>
      </Card.Body>
    </Card>
  );

  return (
    <React.Fragment>
      <Header />
      <div className="main main-app p-3 p-lg-4" style={{ background: '#f5f7fa', minHeight: '100vh' }}>
        <div className="container-fluid">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4">
            <div>
              <h4 className="main-title mb-1"><Shop className="me-2" />Tableau de bord</h4>
              <p className="text-muted mb-0">
                <Calendar className="me-2" />
                {periodLabel} • {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
              </p>
            </div>
            <div className="d-flex gap-2 flex-wrap">
              {/* 👈 ButtonGroup avec Année et Tous */}
              <ButtonGroup>
                <Button 
                  variant={timeRange === "day" ? "primary" : "outline-primary"} 
                  onClick={() => handleTimeRangeChange("day")} 
                  size="sm"
                  disabled={isFiltering}
                >
                  Jour
                </Button>
                <Button 
                  variant={timeRange === "week" ? "primary" : "outline-primary"} 
                  onClick={() => handleTimeRangeChange("week")} 
                  size="sm"
                  disabled={isFiltering}
                >
                  Semaine
                </Button>
                <Button 
                  variant={timeRange === "month" ? "primary" : "outline-primary"} 
                  onClick={() => handleTimeRangeChange("month")} 
                  size="sm"
                  disabled={isFiltering}
                >
                  Mois
                </Button>
                <Button 
                  variant={timeRange === "year" ? "primary" : "outline-primary"} 
                  onClick={() => handleTimeRangeChange("year")} 
                  size="sm"
                  disabled={isFiltering}
                >
                  Année
                </Button>
                <Button 
                  variant={timeRange === "all" ? "primary" : "outline-primary"} 
                  onClick={() => handleTimeRangeChange("all")} 
                  size="sm"
                  disabled={isFiltering}
                >
                  Tous
                </Button>
              </ButtonGroup>
              <Dropdown>
                <Dropdown.Toggle variant="outline-secondary" size="sm" disabled={exportLoading || isFiltering}>
                  {exportLoading ? <Spinner animation="border" size="sm" /> : <Download className="me-1" />} Exporter
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={exportPDF} disabled={exportLoading}>
                    <FilePdf className="me-2 text-danger" /> PDF
                  </Dropdown.Item>
                  <Dropdown.Item onClick={exportExcel} disabled={exportLoading}>
                    <FileEarmarkExcel className="me-2 text-success" /> Excel
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Button 
                variant="outline-secondary" 
                size="sm" 
                onClick={() => loadDashboardData(true)} 
                disabled={refreshLoading || isFiltering}
              >
                {refreshLoading ? <Spinner animation="border" size="sm" /> : <ClockHistory />}
              </Button>
            </div>
          </div>

          {error && (
            <Card className="border-0 shadow-sm mb-4">
              <Card.Body>
                <Alert variant="danger" className="mb-0">
                  <ExclamationCircle className="me-2" /> {error}
                </Alert>
              </Card.Body>
            </Card>
          )}

          {/* Statistiques */}
          <Row className="g-3 mb-4">
            {isFiltering || loadingStats ? (
              <>
                <Col md={6} lg={3}><SkeletonStatCard /></Col>
                <Col md={6} lg={3}><SkeletonStatCard /></Col>
                <Col md={6} lg={3}><SkeletonStatCard /></Col>
                <Col md={6} lg={3}><SkeletonStatCard /></Col>
              </>
            ) : (
              <>
                <Col md={6} lg={3}>
                  <StatCard 
                    title="Contribuables" 
                    value={stats.totalContribuables} 
                    icon={People} 
                    color="primary" 
                    loading={false}
                    description={`${stats.totalContribuables} au total`}
                  />
                </Col>
                <Col md={6} lg={3}>
                  <StatCard 
                    title="Collecte de la période" 
                    value={formatCurrency(stats.totalCollecteJour)} 
                    icon={Cash} 
                    color="success" 
                    loading={false}
                    description="Montant collecté"
                  />
                </Col>
                <Col md={6} lg={3}>
                  <StatCard 
                    title={getObjectiveLabel()}
                    value={formatCurrency(getCurrentObjective())}
                    icon={Bullseye} 
                    color="info" 
                    loading={false}
                    description={getObjectiveDescription()}
                  />
                </Col>
                <Col md={6} lg={3}>
                  <StatCard 
                    title="Taux d'atteinte" 
                    value={`${getCurrentAchievement()}%`}
                    icon={GraphUp} 
                    color={getCurrentAchievement() >= 80 ? "success" : "warning"}
                    loading={false}
                    description={getCurrentAchievement() >= 80 ? "Objectif atteint" : "En dessous de l'objectif"}
                  />
                </Col>
              </>
            )}
          </Row>

          {/* Objectifs et Performance */}
          <Row className="g-4 mb-4">
            <Col lg={6}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Header className="bg-white border-bottom py-3">
                  <div className="d-flex align-items-center">
                    <div className="bg-primary bg-opacity-10 rounded-3 p-2 me-3">
                      <Bullseye className="text-primary" size={20} />
                    </div>
                    <div>
                      <Card.Title as="h6" className="mb-0 fw-semibold" style={{ fontSize: '15px' }}>Suivi des Objectifs</Card.Title>
                      <small className="text-muted" style={{ fontSize: '11px' }}>
                        Performance par période - {periodLabel}
                      </small>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body className="pt-3">
                  {isFiltering || loadingObjectives ? (
                    <div className="text-center py-5">
                      <Spinner animation="border" variant="primary" />
                      <p className="mt-2 text-muted small">Chargement des objectifs...</p>
                    </div>
                  ) : (
                    <Row className="g-2">
                      <Col md={4}>
                        <div className="text-center p-2 rounded-3 bg-light bg-opacity-50 h-100">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <span className="badge bg-primary rounded-pill px-2 py-1" style={{ fontSize: '10px' }}>
                              <Clock className="me-1" size={10} /> Journalier
                            </span>
                            <span className={`fw-bold ${objectives.daily.percentage >= 80 ? 'text-success' : objectives.daily.percentage >= 50 ? 'text-warning' : 'text-danger'}`} style={{ fontSize: '13px' }}>
                              {objectives.daily.percentage}%
                            </span>
                          </div>
                          <ReactApexChart 
                            options={{ 
                              ...objectiveChartOptionsSmall, 
                              labels: ['Objectif journalier'],
                              colors: [objectives.daily.percentage >= 80 ? '#2ecc71' : objectives.daily.percentage >= 50 ? '#f39c12' : '#e74c3c']
                            }} 
                            series={[objectives.daily.percentage]} 
                            type="radialBar" 
                            height={150} 
                          />
                          <div className="mt-1">
                            <div className="d-flex justify-content-between small" style={{ fontSize: '10px' }}>
                              <span className="text-success fw-bold">{formatCurrency(objectives.daily.collected)}</span>
                              <span className="text-muted">/</span>
                              <span className="text-muted">{formatCurrency(objectives.daily.target)}</span>
                            </div>
                            <ProgressBar 
                              now={objectives.daily.percentage} 
                              variant={objectives.daily.percentage >= 80 ? "success" : objectives.daily.percentage >= 50 ? "warning" : "danger"}
                              style={{ height: '3px', borderRadius: '2px' }}
                              className="mt-1"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="text-center p-2 rounded-3 bg-light bg-opacity-50 h-100">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <span className="badge bg-info rounded-pill px-2 py-1" style={{ fontSize: '10px' }}>
                              <Calendar className="me-1" size={10} /> Hebdomadaire
                            </span>
                            <span className={`fw-bold ${objectives.weekly.percentage >= 80 ? 'text-success' : objectives.weekly.percentage >= 50 ? 'text-warning' : 'text-danger'}`} style={{ fontSize: '13px' }}>
                              {objectives.weekly.percentage}%
                            </span>
                          </div>
                          <ReactApexChart 
                            options={{ 
                              ...objectiveChartOptionsSmall, 
                              labels: ['Objectif hebdomadaire'],
                              colors: [objectives.weekly.percentage >= 80 ? '#2ecc71' : objectives.weekly.percentage >= 50 ? '#f39c12' : '#e74c3c']
                            }} 
                            series={[objectives.weekly.percentage]} 
                            type="radialBar" 
                            height={150} 
                          />
                          <div className="mt-1">
                            <div className="d-flex justify-content-between small" style={{ fontSize: '10px' }}>
                              <span className="text-success fw-bold">{formatCurrency(objectives.weekly.collected)}</span>
                              <span className="text-muted">/</span>
                              <span className="text-muted">{formatCurrency(objectives.weekly.target)}</span>
                            </div>
                            <ProgressBar 
                              now={objectives.weekly.percentage} 
                              variant={objectives.weekly.percentage >= 80 ? "success" : objectives.weekly.percentage >= 50 ? "warning" : "danger"}
                              style={{ height: '3px', borderRadius: '2px' }}
                              className="mt-1"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="text-center p-2 rounded-3 bg-light bg-opacity-50 h-100">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <span className="badge bg-success rounded-pill px-2 py-1" style={{ fontSize: '10px' }}>
                              <GraphUp className="me-1" size={10} /> Mensuel
                            </span>
                            <span className={`fw-bold ${objectives.monthly.percentage >= 80 ? 'text-success' : objectives.monthly.percentage >= 50 ? 'text-warning' : 'text-danger'}`} style={{ fontSize: '13px' }}>
                              {objectives.monthly.percentage}%
                            </span>
                          </div>
                          <ReactApexChart 
                            options={{ 
                              ...objectiveChartOptionsSmall, 
                              labels: ['Objectif mensuel'],
                              colors: [objectives.monthly.percentage >= 80 ? '#2ecc71' : objectives.monthly.percentage >= 50 ? '#f39c12' : '#e74c3c']
                            }} 
                            series={[objectives.monthly.percentage]} 
                            type="radialBar" 
                            height={150} 
                          />
                          <div className="mt-1">
                            <div className="d-flex justify-content-between small" style={{ fontSize: '10px' }}>
                              <span className="text-success fw-bold">{formatCurrency(objectives.monthly.collected)}</span>
                              <span className="text-muted">/</span>
                              <span className="text-muted">{formatCurrency(objectives.monthly.target)}</span>
                            </div>
                            <ProgressBar 
                              now={objectives.monthly.percentage} 
                              variant={objectives.monthly.percentage >= 80 ? "success" : objectives.monthly.percentage >= 50 ? "warning" : "danger"}
                              style={{ height: '3px', borderRadius: '2px' }}
                              className="mt-1"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="text-center p-2 rounded-3 bg-light bg-opacity-50 h-100">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <span className="badge bg-warning text-dark rounded-pill px-2 py-1" style={{ fontSize: '10px' }}>
                              <Calendar className="me-1" size={10} /> Annuel
                            </span>
                            <span className={`fw-bold ${objectives.yearly.percentage >= 80 ? 'text-success' : objectives.yearly.percentage >= 50 ? 'text-warning' : 'text-danger'}`} style={{ fontSize: '13px' }}>
                              {objectives.yearly.percentage}%
                            </span>
                          </div>
                          <ReactApexChart 
                            options={{ 
                              ...objectiveChartOptionsSmall, 
                              labels: ['Objectif annuel'],
                              colors: [objectives.yearly.percentage >= 80 ? '#2ecc71' : objectives.yearly.percentage >= 50 ? '#f39c12' : '#e74c3c']
                            }} 
                            series={[objectives.yearly.percentage]} 
                            type="radialBar" 
                            height={150} 
                          />
                          <div className="mt-1">
                            <div className="d-flex justify-content-between small" style={{ fontSize: '10px' }}>
                              <span className="text-success fw-bold">{formatCurrency(objectives.yearly.collected)}</span>
                              <span className="text-muted">/</span>
                              <span className="text-muted">{formatCurrency(objectives.yearly.target)}</span>
                            </div>
                            <ProgressBar 
                              now={objectives.yearly.percentage} 
                              variant={objectives.yearly.percentage >= 80 ? "success" : objectives.yearly.percentage >= 50 ? "warning" : "danger"}
                              style={{ height: '3px', borderRadius: '2px' }}
                              className="mt-1"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="text-center p-2 rounded-3 bg-light bg-opacity-50 h-100">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <span className="badge bg-dark rounded-pill px-2 py-1" style={{ fontSize: '10px' }}>
                              <ListCheck className="me-1" size={10} /> Total
                            </span>
                            <span className={`fw-bold ${objectives.total.percentage >= 80 ? 'text-success' : objectives.total.percentage >= 50 ? 'text-warning' : 'text-danger'}`} style={{ fontSize: '13px' }}>
                              {objectives.total.percentage}%
                            </span>
                          </div>
                          <ReactApexChart 
                            options={{ 
                              ...objectiveChartOptionsSmall, 
                              labels: ['Objectif total'],
                              colors: [objectives.total.percentage >= 80 ? '#2ecc71' : objectives.total.percentage >= 50 ? '#f39c12' : '#e74c3c']
                            }} 
                            series={[objectives.total.percentage]} 
                            type="radialBar" 
                            height={150} 
                          />
                          <div className="mt-1">
                            <div className="d-flex justify-content-between small" style={{ fontSize: '10px' }}>
                              <span className="text-success fw-bold">{formatCurrency(objectives.total.collected)}</span>
                              <span className="text-muted">/</span>
                              <span className="text-muted">{formatCurrency(objectives.total.target)}</span>
                            </div>
                            <ProgressBar 
                              now={objectives.total.percentage} 
                              variant={objectives.total.percentage >= 80 ? "success" : objectives.total.percentage >= 50 ? "warning" : "danger"}
                              style={{ height: '3px', borderRadius: '2px' }}
                              className="mt-1"
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  )}
                </Card.Body>
              </Card>
            </Col>

            {/* Évolution des Collectes */}
            <Col lg={6}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Header className="bg-white border-bottom py-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="bg-success bg-opacity-10 rounded-3 p-2 me-3">
                        <GraphUp className="text-success" size={20} />
                      </div>
                      <div>
                        <Card.Title as="h6" className="mb-0 fw-semibold" style={{ fontSize: '15px' }}>Évolution des Collectes</Card.Title>
                        <small className="text-muted" style={{ fontSize: '11px' }}>
                          Tendance des encaissements - {periodLabel}
                        </small>
                      </div>
                    </div>
                    {!isFiltering && evolutionData.collecte.some(v => v > 0) && (
                      <div className="d-flex gap-3" style={{ fontSize: '10px' }}>
                        <div className="d-flex align-items-center">
                          <span className="d-inline-block rounded-circle me-1" style={{ width: '8px', height: '8px', backgroundColor: '#2ecc71' }} />
                          <small className="text-muted">Collecté</small>
                        </div>
                        <div className="d-flex align-items-center">
                          <span className="d-inline-block rounded-circle me-1" style={{ width: '8px', height: '8px', backgroundColor: '#9b59b6' }} />
                          <small className="text-muted">Objectif</small>
                        </div>
                      </div>
                    )}
                  </div>
                </Card.Header>
                <Card.Body>
                  {isFiltering || loadingEvolution ? (
                    <div className="text-center py-5">
                      <Spinner animation="border" variant="primary" />
                      <p className="mt-2 text-muted small">Chargement des données...</p>
                    </div>
                  ) : evolutionData.collecte.some(v => v > 0) ? (
                    <>
                      <ReactApexChart 
                        options={revenueChartOptions} 
                        series={revenueSeries} 
                        type="area" 
                       
                      />
                      {stats.tauxRecouvrement > 0 && (
                        <div className="mt-2 p-2 bg-light rounded-3">
                          <Row className="g-1 text-center">
                            <Col xs={4}>
                              <div className="p-1 bg-white rounded-3 shadow-sm">
                                <small className="text-muted d-block" style={{ fontSize: '9px' }}>Total Collecté</small>
                                <span className="fw-bold text-success" style={{ fontSize: '13px' }}>{formatCurrency(stats.totalPaye)}</span>
                              </div>
                            </Col>
                            <Col xs={4}>
                              <div className="p-1 bg-white rounded-3 shadow-sm">
                                <small className="text-muted d-block" style={{ fontSize: '9px' }}>Objectif</small>
                                <span className="fw-bold text-primary" style={{ fontSize: '13px' }}>{formatCurrency(stats.totalAttendu)}</span>
                              </div>
                            </Col>
                            <Col xs={4}>
                              <div className="p-1 bg-white rounded-3 shadow-sm">
                                <small className="text-muted d-block" style={{ fontSize: '9px' }}>Taux atteint</small>
                                <span className={`fw-bold ${stats.tauxRecouvrement >= 80 ? 'text-success' : stats.tauxRecouvrement >= 50 ? 'text-warning' : 'text-danger'}`} style={{ fontSize: '13px' }}>
                                  {stats.tauxRecouvrement}%
                                </span>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="text-center py-5">
                      <div className="bg-light rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: '56px', height: '56px' }}>
                        <GraphUp size={28} className="text-muted opacity-25" />
                      </div>
                      <h6 className="text-muted" style={{ fontSize: '13px' }}>Aucune donnée disponible</h6>
                      <p className="text-muted small" style={{ fontSize: '11px' }}>Aucune collecte enregistrée pour cette période</p>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Section Taxe Salubrité */}
          <Row className="g-4 mb-4">
            <Col lg={6}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Header className="bg-white border-bottom py-3">
                  <div className="d-flex align-items-center">
                    <div className="bg-danger bg-opacity-10 rounded-3 p-2 me-3">
                      <Trash className="text-danger" size={20} />
                    </div>
                    <div>
                      <Card.Title as="h6" className="mb-0 fw-semibold" style={{ fontSize: '15px' }}>
                        {salubriteStats.taxe_nom || 'Taxe Salubrité'}
                      </Card.Title>
                      <small className="text-muted" style={{ fontSize: '11px' }}>
                        Suivi analytique - {periodLabel}
                      </small>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  {isFiltering || loadingSalubrite ? (
                    <div className="text-center py-5">
                      <Spinner animation="border" variant="primary" />
                      <p className="mt-2 text-muted small">Chargement des données...</p>
                    </div>
                  ) : (
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded-3">
                            <span className="text-muted small">Total attendu</span>
                            <span className="fw-bold text-danger">{formatCurrency(salubriteStats.total_attendu)}</span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded-3 mt-2">
                            <span className="text-muted small">Total collecté</span>
                            <span className="fw-bold text-success">{formatCurrency(salubriteStats.total_collecte)}</span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded-3 mt-2">
                            <span className="text-muted small">Taux de recouvrement</span>
                            <span className={`fw-bold ${salubriteStats.taux_recouvrement >= 80 ? 'text-success' : 'text-warning'}`}>
                              {salubriteStats.taux_recouvrement}%
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded-3 mt-2">
                            <span className="text-muted small">Contribuables</span>
                            <span className="fw-bold">{salubriteStats.nombre_contribuables}</span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded-3 mt-2">
                            <span className="text-muted small">Paiements</span>
                            <span className="fw-bold">{salubriteStats.nombre_paiements}</span>
                          </div>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="text-center">
                          <ReactApexChart 
                            options={salubriteChartOptions} 
                            series={salubriteSeries} 
                            type="area" 
                            height={180} 
                          />
                          <div className="mt-2">
                            <div className="d-flex justify-content-between small">
                              <span className="text-muted">Évolution sur 7 jours</span>
                              <span className="text-muted">{periodLabel}</span>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  )}
                </Card.Body>
              </Card>
            </Col>

            {/* Performance des Agents */}
            <Col lg={6}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Header className="bg-white border-bottom d-flex justify-content-between align-items-center">
                  <div>
                    <Card.Title as="h6" className="mb-0"><Person className="me-2" />Performance des Agents</Card.Title>
                    <small className="text-muted">Classement par volume collecté - {periodLabel}</small>
                  </div>
                  <Button variant="outline-primary" size="sm" as={Link} to="/supervisor/agents">Voir tout</Button>
                </Card.Header>
                <Card.Body>
                  {isFiltering || loadingAgents ? (
                    <div className="text-center py-4">
                      <Spinner animation="border" variant="primary" />
                      <p className="mt-2 text-muted">Chargement des agents...</p>
                    </div>
                  ) : dashboardData.agentsPerformance.length > 0 ? (
                    <>
                      <ReactApexChart options={agentsChartOptions} series={agentsSeries} type="bar" height={200} />
                      <Table hover responsive className="mt-2 mb-0">
                        <thead>
                          <tr><th>#</th><th>Agent</th><th>Collecté</th><th>Objectif</th><th>Performance</th></tr>
                        </thead>
                        <tbody>
                          {dashboardData.agentsPerformance.slice(0, 5).map((agent, idx) => (
                            <tr key={idx}>
                              <td>{idx === 0 ? <Trophy className="text-warning" /> : idx + 1}</td>
                              <td><strong>{agent.nom || 'Agent'}</strong></td>
                              <td className="text-success fw-bold">{formatCurrency(agent.collecte || 0)}</td>
                              <td>{formatCurrency(agent.objectif || 0)}</td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <ProgressBar now={agent.performance || 0} variant={agent.performance >= 100 ? "success" : "warning"} style={{ width: '60px', height: '4px' }} />
                                  <Badge bg={agent.performance >= 100 ? "success" : "warning"} className="ms-2">{agent.performance || 0}%</Badge>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </>
                  ) : (
                    <div className="text-center py-4"><p className="text-muted">Aucun agent</p></div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Activités récentes */}
          <Row>
            <Col lg={12}>
              <Card className="border-0 shadow-sm">
                <Card.Header className="bg-white border-bottom">
                  <Card.Title as="h6" className="mb-0"><Clock className="me-2" />Activités Récentes</Card.Title>
                  <small className="text-muted">Dernières transactions - {periodLabel}</small>
                </Card.Header>
                <Card.Body className="p-0">
                  {isFiltering ? (
                    <div className="text-center py-4">
                      <Spinner animation="border" variant="primary" />
                      <p className="mt-2 text-muted">Chargement des activités...</p>
                    </div>
                  ) : dashboardData.recentPayments.length > 0 ? (
                    <Table hover responsive className="mb-0">
                      <thead className="bg-light">
                        <tr><th>Heure</th><th>Contribuable</th><th>Montant</th><th>Agent</th><th>Statut</th></tr>
                      </thead>
                      <tbody>
                        {dashboardData.recentPayments.slice(0, 10).map((payment, idx) => (
                          <tr key={idx}>
                            <td>{formatDate(payment.created_at)}</td>
                            <td><strong>{payment.contribuable}</strong></td>
                            <td className="text-success fw-bold">{formatCurrency(payment.montant)}</td>
                            <td>{payment.agent || '-'}</td>
                            <td><Badge bg="success" className="rounded-pill"><CheckCircle className="me-1" />Payé</Badge></td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <div className="text-center py-4 text-muted">Aucune activité récente</div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Footer />
        </div>
      </div>

      <style>{`
        .stats-card { transition: transform 0.3s ease, box-shadow 0.3s ease; border-radius: 12px; }
        .stats-card:hover { transform: translateY(-5px); box-shadow: 0 10px 30px rgba(0,0,0,0.08) !important; }
      `}</style>
    </React.Fragment>
  );
}